import React, { useEffect, useState } from 'react';
import { Button, Input, Space } from 'antd';
import classNames from 'classnames';
import { getQueryString } from 'utils/utils';
import { CompanyCode,  } from 'components/TableSearchBox';
import { addNewSearch } from 'utils/utils';
import 'components/TableSearchBox/index.scss';
import { SearchRangePicker } from 'components/atoms'
import moment, { Moment } from 'moment';
import { RangeValue } from 'rc-picker/lib/interface';
import { dateFormat } from 'utils/date-utils';

const cx = classNames.bind('./index.scss');
export interface ProjectSearchBoxProp {
  onSearch: (params: any) => void;
}

const ProjectSearchBox = ({onSearch}: ProjectSearchBoxProp): React.ReactElement => {
  /* ======================================================
   * hooks
   * ====================================================== */
  
  /* ======================================================
   * variables
   * ====================================================== */

  /* ======================================================
   * states
   * ====================================================== */
  const [searchInput, setSearchInput] = useState<string>('');
  const [searchRange, setSearchRange] = useState<RangeValue<Moment>|null>();
  const [searchCompany, setSearchCompany] = useState<number>();


  /* ======================================================
   * events
   * ====================================================== */
  const onChange = (e) => {
    setSearchInput(e.target.value);
  };

  const onClickReset = (e) => {
    setSearchInput('');
    setSearchRange(null);
    setSearchCompany(0);

    onSearch({});
  };

  const onChangeSearch = (data: any) => {
    const searchDateS = searchRange && searchRange[0] ? searchRange[0].format('YYYY-MM-DD') : '';
    const searchDateE = searchRange && searchRange[1] ? searchRange[1].format('YYYY-MM-DD') : '';

    const params = { 
      searchDateStart: searchDateS, 
      searchDateEnd: searchDateE, 
      company: searchCompany,
      search: searchInput,
      pageNo: 1 }

    onSearch({...params, data});   
  };

  const onChangePeriod = (date: RangeValue<Moment>, dateString: [string, string]) => {
    setSearchRange(date);

    const searchDateS = dateString[0] ? dateFormat(dateString[0], 'YYYY-MM-DD') : '';
    const searchDateE = dateString[1] ? dateFormat(dateString[1], 'YYYY-MM-DD') : '';

    onSearch({ 
      searchDateStart: searchDateS, 
      searchDateEnd: searchDateE, 
      company: searchCompany,
      search: searchInput,
      pageNo: 1 });
  };

  /* ======================================================
   * effects
   * ====================================================== */

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <div className={cx('tableSearchBoxWrapper')}>
      <Space direction='vertical'>
        <Space>
        <SearchRangePicker value={searchRange} format="YYYY-MM-DD" onChange={onChangePeriod} style={{width:'250px'}} /> 
          <CompanyCode codeValue={searchCompany} onChangeSelect={(value)=>onChangeSearch({ company: value, pageNo: 1 })} />
          <Input.Search
            className={cx('searchInput')}
            value={searchInput}
            placeholder="검색어를 입력하세요"
            onChange={onChange}
            onSearch={(value)=>onChangeSearch({ search: value, pageNo: 1 })}
            allowClear
          />
          <Button onClick={onClickReset}>
            검색초기화
          </Button>                
        </Space>      
      </Space>
    </div>
  );
};

export default ProjectSearchBox;
